import {ChangeDetectorRef, Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SessionService} from '../../services/session/session.service';
import {Actions, Select, Store} from '@ngxs/store';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {PaymentService} from '../../services/payment/payment.service';
import {TransactionService} from '../../services/transaction/transaction.service';
import {DomSanitizer} from '@angular/platform-browser';
import {Session} from '../../interfaces/session-data';
import {MapState} from '../shared/map.state';
import {Observable, Subject} from 'rxjs';
import {PaymentType} from '../../interfaces/payment/PaymentType';
import {ThemePalette} from '@angular/material/core';
import {ProgressSpinnerMode} from '@angular/material/progress-spinner';
import {PaymentMethodsCard, PaymentMethodsOther} from '../../interfaces/payment-methods';
import {MaskedData} from "../../interfaces/visa-src/MaskedData";

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss']
})
export class PaymentsComponent implements OnInit {

  oneClickEnabled = false;
  public maskedData: Subject<MaskedData> = new Subject<MaskedData>();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private sessionService: SessionService,
    private route: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    private store: Store,
    private breakpointObserver: BreakpointObserver,
    public sanitizer: DomSanitizer
  ) {

    /**
     * From session:
     *  payment types
     *  merchant config data (colour scheme, label etc.), amounts, order details
     *  card tokenization if possible
     *  direct route into payment method if not:
     *   more than 1 payment method &&
     *   more than 1 card (tokenized card with puid
     */

    // actions$.pipe(
    //   ofActionDispatched(SetSessionStorage))
    //   .subscribe((data: Session) => {
    //     this.sessionData = (session as Session);
    //     this.configurePaymentTypes();
    //   });

    this.sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    this.configurePaymentTypes();
    this.hidePgLogo = this.sessionData?.sessionDisplayInformation?.hidePgLogo === 'true';
    breakpointObserver.observe([
      Breakpoints.HandsetPortrait
    ]).subscribe(result => {
      this.mobile = result.matches;
      if (result.matches) {
        this.cols = 1;
      } else {
        this.cols = 3;
      }
    });
  }
  @Select(MapState) sessionStorage$: Observable<object>;
  paymentTypes: PaymentType[];
  // spinner
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'determinate';
  value = 50;
  diameter = 80;
  sessionData: Session;
  cols;
  mobile;
  public paymentMethodsCards: PaymentMethodsCard[];
  public paymentMethodsOther: PaymentMethodsOther[];
  public clickToPayMethod: boolean;
  loading = true;
  hidePgLogo = false;

  configurePaymentTypes() {
    this.paymentTypes = this.sessionData.virtualConfiguration.paymentTypes;
    this.paymentMethodsCards = this.paymentTypes.filter(paymentType => paymentType.code === 'CARD');
    this.paymentMethodsOther = this.paymentTypes.filter(paymentType => paymentType.code !== 'CARD' && paymentType.code !== 'DISBURSEMENT');
    this.clickToPayMethod = this.paymentTypes.filter(paymentType => paymentType.code === 'CLICK_TO_PAY').length > 0;
    this.loading = false;
  }

  ngOnInit(): void {
  }

  setMaskedEvent($event: MaskedData) {
    console.log('set masked event', $event);
    this.maskedData.next($event);

  }
}
